<template>
    <span>
        <slot name="es" v-if="lang == 'es'"></slot>
        <slot name="en" v-else-if="lang == 'en'"></slot>
    </span>
</template>

<script>

export default {
    name: 'text-lang',
    props: {
        lang: {
            type: String,
            required: true
        }
    }
}
</script>
